import {
  Component,
  DestroyRef,
  OnInit,
  computed,
  inject,
  signal,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { ModalService } from '@ls-commons/utils/modals';

import { HttpClient } from '@angular/common/http';
import { CheckboxModule } from 'primeng/checkbox';
import { Product, ProductIngredient } from '../cart.model';
import { CartService } from '../cart.service';
import { QuantityCounterComponent } from '../quantity-counter/quantity-counter.component';
import { NgFor } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import _ from 'lodash';
import { IngredientNamePipe } from 'src/app/pipes/ingredient-name/ingredient-name.pipe';

@Component({
  selector: 'app-product-ingredients',
  standalone: true,
  imports: [
    ButtonModule,
    SelectButtonModule,
    ReactiveFormsModule,
    SkeletonModule,
    CheckboxModule,
    QuantityCounterComponent,
    NgFor,
    DividerModule,
  ],
  templateUrl: './product-ingredients.component.html',
  styleUrl: './product-ingredients.component.scss',
})
export class ProductIngredientsComponent implements OnInit {
  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);
  cartService = inject(CartService);
  http = inject(HttpClient);
  saving = false;
  product: Product | null = null;
  updatedQuantity: number = 0;
  items: ProductIngredient[];

  private _isLoading = signal<boolean>(true);
  public isLoading = computed(() => this._isLoading());

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    readonly fb: FormBuilder
  ) {
    const { product } = this.config.data;
    this.product = {
      ...product,
      finalIngredients: product.ingredients
        ? JSON.parse(product.ingredients)
        : [],
      finalIngredientsName: [],
    };
    this.items = _.cloneDeep(this.cartService.ingredientsList);
  }

  ngOnInit(): void {
    const productIngredients: Array<number> = this.product?.ingredients
      ? JSON.parse(this.product?.ingredients.toString())
      : [];

    productIngredients.forEach(ingredient => {
      this.items.find((productIngredient, index) => {
        if (productIngredient.productIngredientId === ingredient) {
          this.items[index].initialQuantity = 1;
        }
      });
    });
  }

  closeDialog() {
    this.ref.close(false);
  }

  addToCart() {
    this.cartService.addProduct(this.product!, 1);
    this.modalService.showSuccessMessage(`Producto añadido`);
    this.ref.close(true);
  }

  changeQuantity(productId: number, value: number | null) {
    if (value !== null) {
      // this.updatedQuantity = value;
      // this.cartService.changeProductQuantity(productId, value);
    }
  }

  calculateExtraAmount(ingredient: ProductIngredient, value: number) {
    const newValue = value - ingredient.initialQuantity!;
    ingredient.totalPrice = newValue > 0 ? ingredient.price * newValue : 0;
  }

  calculatePrice() {
    let extraPrice = 0;
    this.items.forEach(item => {
      extraPrice += item.totalPrice;
    });
    this.product!.extraPrice = extraPrice;
  }

  updateFinalIngredients(productIngredientId: number, value: number) {
    const final = this.product!.finalIngredients.filter(
      ingredient => ingredient !== productIngredientId
    );

    this.product!.finalIngredients = final;

    for (let index = 0; index < value; index++) {
      this.product?.finalIngredients.push(productIngredientId);
    }

    this.updateFinalIngredientsName();
  }

  updateFinalIngredientsName() {
    const namePipe = new IngredientNamePipe(this.cartService);
    this.product!.finalIngredientsName = [];

    this.product?.finalIngredients.forEach(ingredient => {
      this.product?.finalIngredientsName.push(namePipe.transform(ingredient));
    });
  }
}
